<script setup lang="ts">
import { useFormContainer } from "~/composables/useFormContainer";
import FormCard from "~/components/ui/FormCard.vue";

defineProps({
  progress: { type: Number, required: true },
});

const { FormContainer } = useFormContainer();

const emit = defineEmits(["init", "submit", "decline"]);
onMounted(() => emit("init"));
</script>

<template>
  <FormContainer :progress="progress" title="Non perdere questa occasione!">
    <FormCard
      title="Non perdere questa occasione!"
      :header-class="'pageTitle mb-4'" 
      @submit.prevent="emit('submit')"
    >
      <p class="pb-4">
        Cofidis ti regala il primo mese di
        <strong>accesso gratuito</strong> al CLUB PLUS, in cui puoi
        usufruire di esperienze uniche in formula 2x1: paghi per uno e
        invita chi vuoi! Dopo il mese gratuito, soli 9,90 € al mese. Non
        lasciarti sfuggire questa occasione!
      </p>
    </FormCard>

    <div class="text-center text-gray-700 mt-4 mb-8">
      <button
        data-testid="decline"
        class="underline cursor-pointer"
        @click="emit('decline')"
      >
        Procedi senza Club
      </button>
    </div>
  </FormContainer>
</template>

<style scoped></style>
